import React from 'react'
import { IonHeader, IonToolbar, IonFooter, IonListHeader } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getBodyAssessmentSelector } from '../selectors'
import { setShowExamModal } from '../store/bodyAssessment.actions'
import ActionButtons from '../../../../components/actionButtons/ActionButtons.component'
import MultiActionPanelComponent from '../../../../components/multiActionPanel/MultiActionPanel.component'
import ExamsPicklistContent from '../examsPicklist/ExamsPicklist.content'
import useDeviceMetrics from '../../../../utilities/useDeviceMetrics'

const ExamModal: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { showExamModal } = useSelector(getBodyAssessmentSelector)
  const { isTablet } = useDeviceMetrics()

  const closeExamsModal = () => {
    dispatch(setShowExamModal(false))
  }

  const examsModalButtons = [
    {
      label: t('common.buttons.Cancel'),
      className: 'btn btn-secondary mr-8',
      onClick: closeExamsModal,
    },
  ]

  const otherModalProps = () => {
    const obj: any = {}
    if (isTablet) {
      obj.resizableBoxConstraints = {
        width: 500,
        height: 560,
      }
    }
    if (!isTablet) {
      obj.footerContent = (
        <IonFooter className='ion-no-border'>
          <IonToolbar color='light' className='p-10 footer-class'>
            <ActionButtons actionButtonObj={examsModalButtons} />
          </IonToolbar>
        </IonFooter>
      )
    }
    obj.headerContent = (
      <IonHeader className='ion-no-border header-content'>
        <IonToolbar color='light' className='p-10'>
          <IonListHeader className='header-class ion-no-padding'>Add or Modify Exams</IonListHeader>
        </IonToolbar>
      </IonHeader>
    )
    return obj
  }

  return (
    <MultiActionPanelComponent
      type='tabletSupportModal'
      dataTestId='examPicklistModal'
      isOpen={showExamModal}
      onClose={closeExamsModal}
      showPopover={true}
      modalClasses='exams-picklist-modal'
      popOverClasses='exams-picklist-popover'
      content={<ExamsPicklistContent />}
      {...otherModalProps()}
    />
  )
}
export default ExamModal
